export const rangeQuestionOptions = ['1', '2', '3', '4', '5', 'not-present']
export const npsQuestionOptions = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

export const pollIsAlreadyFilledLocalStoragePrefix = 'iSA-surveys-'

const twoDigits = (number) => `0${number}`.slice(-2)

// Data kursu po polsku (01.09.2026) w strefie Europe/Warsaw, niezależnie od strefy urządzenia kursanta.
// Wcześniej moment formatował w strefie przeglądarki: kurs od 2026-09-01T00:00Z w Nowym Jorku zaczynał się 31/08/2026.
export const formatDate = (value) => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return null

  try {
    return new Intl.DateTimeFormat('pl-PL', {
      timeZone: 'Europe/Warsaw',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date)
  } catch (error) {
    // Przeglądarka bez Intl albo bez danych stref czasowych: ten sam format w strefie urządzenia.
    return `${twoDigits(date.getDate())}.${twoDigits(date.getMonth() + 1)}.${date.getFullYear()}`
  }
}

export const requireTextAnswersIfMarkIsLowerThanX = 4
export const pollTemplatesIdsForOkButton = ['5e01f138dee919717c9f6321']
